var _style, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNotification(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "notification_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 1024 1024"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#f9af17",
    d: "M627.6 840c-18.1 0-32.9 14.8-32.9 32.9 0 45.6-37.1 82.7-82.7 82.7s-82.7-37.1-82.7-82.7c0-18.1-14.8-32.9-32.9-32.9s-32.9 14.8-32.9 32.9c0 81.9 66.6 148.5 148.5 148.5s148.5-66.6 148.5-148.5c0-18.1-14.8-32.9-32.9-32.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#35a4dd",
    d: "M876 692.8c-57.3-48.5-90.2-119.4-90.2-194.5V390.9c0-140.2-105.9-256-241.9-271.9V34.5c0-17.6-14.3-31.9-31.9-31.9s-31.9 14.3-31.9 31.9V119c-136 15.9-241.9 131.7-241.9 271.9v107.4c0 75.1-33 146.1-90.6 194.7-15.9 13.6-25 33.4-25 54.3 0 39.4 32 71.4 71.4 71.4h635.9c39.4 0 71.4-32 71.4-71.4.1-20.8-9.2-40.7-25.3-54.5zM190.5 743C262.7 682 304 592.9 304 498.4V390.9C304 276.3 397.3 183 512 183s208 93.3 208 207.9v107.4c0 94.5 41.4 183.7 113.6 244.8.9.8 2 2.1 2 4.3 0 3.1-2.6 5.6-5.6 5.6H194.1c-3.1 0-5.6-2.6-5.6-5.6-.1-1.7.6-3.2 2-4.4z"
  })));
}

export default SvgNotification;